/**
 * 儲存服務
 * 提供對本地儲存的安全訪問
 */
import { secureStorage } from "@/infrastructure/storage";

/**
 * 儲存服務
 * 封裝基礎設施層的儲存功能，提供應用層安全的儲存訪問
 */
export const storageService = {
  /**
   * 設置儲存項目
   * @param key 儲存鍵名
   * @param value 儲存值
   */
  setItem: (key: string, value: string): void => {
    secureStorage.setItem(key, value);
  },

  /**
   * 獲取儲存項目
   * @param key 儲存鍵名
   * @returns 儲存值或 null
   */
  getItem: (key: string): string | null => {
    return secureStorage.getItem(key);
  },

  /**
   * 移除儲存項目
   * @param key 儲存鍵名
   */
  removeItem: (key: string): void => {
    secureStorage.removeItem(key);
  },

  /**
   * 清空所有儲存項目
   */
  clear: (): void => {
    secureStorage.clear();
  },
};
